import svUi from './sv/ui.json';
import enUi from './en/ui.json';
import svErrors from './sv/errors.json';
import enErrors from './en/errors.json';

// tslint:disable-next-line:variable-name
export const Translations = {
  sv: { errors: svErrors, ui: svUi },
  en: { errors: enErrors, ui: enUi }
};
